module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select1.81f46e0e.png";